import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./basequery";
// import ApiService from "./ApiService";
import axios from "axios";
import ApiService from "./ApiService";

let servicePrefix = "/services";
// let servicePrefix = `${servicePrefix}/extended`;

export const otherServiceApi = createApi({
  reducerPath: "otherServiceApi",
  tagTypes: ["agents"],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    chatGPT: build.mutation({
      query: ({ ...values }) => ({
        url: `${servicePrefix}/chat/`,
        method: "POST",
        data: { ...values },
      }),
    }),
    openAiDalle: build.mutation({
      query: ({ formdata }) => ({
        url: `${servicePrefix}/image-generation/`,
        method: "post",
        data: formdata,
      }),
    }),
    visionAi: build.mutation({
      query: ({ formdata }) => ({
        url: `${servicePrefix}/vision-ai/`,
        method: "post",
        data: formdata,
      }),
    }),
    rekognition: build.mutation({
      query: ({ formdata }) => ({
        url: `${servicePrefix}/rekognition/`,
        method: "post",
        data: formdata,
      }),
    }),

    detectLiveliness: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/liveliness-detection/`,
        method: "post",
        data: formdata,
      }),
    }),
    textToSpeach: build.mutation({
      query: ({ ...values }) => ({
        url: `${servicePrefix}/text-to-speech/`,
        method: "post",
        data: { ...values },
      }),
    }),
    speechToText: build.mutation({
      query: ({ formData }) => ({
        url: `${servicePrefix}/speech-to-text/`,
        method: "post",
        data: formData,
      }),
    }),

    stableDiffusion: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/stable-diffusion/`,
        method: "post",
        data: formdata,
      }),
    }),
    viltvq: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/vilt-vq/`,
        method: "post",
        data: formdata,
      }),
    }),
    gptCaptioning: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/image-captioning/`,
        method: "post",
        data: formdata,
      }),
    }),
    textSummary: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/text-summary/`,
        method: "post",
        data: formdata,
      }),
    }),
    resnet18: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/resnet-18/`,
        method: "post",
        data: formdata,
      }),
    }),
    whisper: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/resnet-50/`,
        method: "post",
        data: formdata,
      }),
    }),
    distillBert: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/text-classification/`,
        method: "post",
        data: formdata,
      }),
    }),
    documentQa: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/document-qa/`,
        method: "post",
        data: formdata,
      }),
    }),
    createVoice: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/voice-cloning/voices/`,
        method: "post",
        data: formdata,
      }),
    }),
    elevenTextTospeech: build.mutation({
      query: (formdata) => ({
        url: `${servicePrefix}/voice-cloning/tts/`,
        method: "post",
        data: formdata,
      }),
    }),
    deleteVoice: build.mutation({
      query: (id) => ({
        url: `${servicePrefix}/voice-cloning/voices/delete/${id}/`,
        method: "delete",
        // data: formdata,
      }),
    }),
    getVoices: build.query({
      query: ({ ...params }) => ({
        url: `${servicePrefix}/voice-cloning/voices/list/`,
        method: "get",
        // params: { ...params },
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.results.map?.(({ id }) => ({ type: "voices", id })),
              { type: "voices", id: "LIST" },
            ]
          : [{ type: "voices", id: "LIST" }],
    }),

    pandasAi: build.mutation({
      query: ({ ...values }) => ({
        url: `/services/ask-your-data/`,
        method: "post",
        data: { ...values },
      }),
    }),

    generateDataset: build.mutation({
      query: ({ ...values }) => ({
        url: "/services/generate-data/",
        method: "post",
        data: { ...values },
      }),
    }),

    createChatbot: build.mutation({
      query: ({ ...values }) => ({
        url: `${servicePrefix}/chatbot/agent/`,
        method: "POST",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "agents", id: "LIST" }],
    }),

    editChatbot: build.mutation({
      query: ({ agentId, ...values }) => ({
        url: `${servicePrefix}/chatbot/agent/${agentId}/`,
        method: "PATCH",
        data: { ...values },
        invalidatesTags: [{ type: "agents", id: "LIST" }],
      }),
    }),

    deleteChatbot: build.mutation({
      query: ({ agentId }) => ({
        url: `${servicePrefix}/chatbot/agent/${agentId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "agents", id: "LIST" }],
    }),

    getSingleChatbot: build.query({
      query: ({ agentId }) => ({
        url: `${servicePrefix}/chatbot/agent/${agentId}`,
        method: "get",
      }),
    }),

    getChatbots: build.query({
      query: () => ({
        url: `${servicePrefix}/chatbot/agent/`,
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.data.map?.(({ id }) => ({ type: "agents", id })),
              { type: "agents", id: "LIST" },
            ]
          : [{ type: "agents", id: "LIST" }],
    }),

    getChatbotSessions: build.query({
      query: ({ agentId }) => ({
        url: `${servicePrefix}/chatbot/${agentId}/session/`,
      }),
    }),
    getChatbotSessionsByDate: build.query({
      query: ({ agentId, params }) => ({
        url: params
          ? `${servicePrefix}/chatbot/${agentId}/session/?from=${params.from}&to=${params.to}`
          : `${servicePrefix}/chatbot/${agentId}/session/`,
      }),
    }),

    getChatbotSession: build.query({
      query: ({ sessionId }) => ({
        url: `${servicePrefix}/chatbot/session/${sessionId}/`,
      }),
    }),

    createChatWithAgent: build.mutation({
      query: ({ agentId, ...values }) => ({
        url: `${servicePrefix}/chatbot/${agentId}/chat/`,
        method: "Post",
        data: { ...values },
      }),
    }),
    getPlaygrounds: build.query({
      query: () => ({
        url: `${servicePrefix}/playground/`,
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.data.map?.(({ id }) => ({ type: "playground", id })),
              { type: "playground", id: "LIST" },
            ]
          : [{ type: "playground", id: "LIST" }],
    }),
  }),
});

export const {
  useChatGPTMutation,
  useVisionAiMutation,
  useTextToSpeachMutation,
  useSpeechToTextMutation,
  useRekognitionMutation,
  useDetectLivelinessMutation,
  useOpenAiDalleMutation,
  useStableDiffusionMutation,
  useViltvqMutation,
  useGptCaptioningMutation,
  useTextSummaryMutation,
  useResnet18Mutation,
  usePandasAiMutation,
  useWhisperMutation,
  useDistillBertMutation,
  useCreateVoiceMutation,
  useDocumentQaMutation,
  useElevenTextTospeechMutation,
  useDeleteVoiceMutation,
  useGetVoicesQuery,
  useGenerateDatasetMutation,
  useCreateChatbotMutation,
  useGetChatbotsQuery,
  useEditChatbotMutation,
  useDeleteChatbotMutation,
  useGetSingleChatbotQuery,
  useGetChatbotSessionsQuery,
  useGetChatbotSessionsByDateQuery,
  useGetChatbotSessionQuery,
  useCreateChatWithAgentMutation,
  useGetPlaygroundsQuery,
} = otherServiceApi;

// export async function apiMutateTextSummary(data) {
//   return axios.post("http://3.89.116.212:8000/api/v1/bart-text-summary/", data);
// }
// export async function apiMutateResnet18(data) {
//   return axios.post("http://3.89.116.212:8000/api/v1/resnet-18/", data);
// }
export async function apiMutateResnet50(data) {
  return axios.post("http://3.89.116.212:8000/api/v1/resnet-50/", data);
}

export async function apiGetVoices() {
  return ApiService.fetchData({
    url: servicePrefix + "/voice-cloning/voices/list/",
    method: "get",
  });
}
